import { render, staticRenderFns } from "./RecordIcons.vue?vue&type=template&id=4d213aa6&scoped=true&"
import script from "./RecordIcons.vue?vue&type=script&lang=js&"
export * from "./RecordIcons.vue?vue&type=script&lang=js&"
import style0 from "./RecordIcons.vue?vue&type=style&index=0&id=4d213aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d213aa6",
  null
  
)

export default component.exports